module.exports = __webpack_public_path__ + "img/wxpay.35cc38e6.png";